import type {
  UpdateJobPlacementInput,
  UpdateJobPlacementMutation,
  UpdateJobPlacementMutationVariables,
} from 'src/App/AppPageBlock/graphql/hirer-types.generated';

import hirerGraphqlClient from './client';
import { mutation } from './schema/mutationUpdateJobPlacement';

export const updateJobPlacement = async ({
  jobId,
  postType,
  submitted,
  userId,
  isPlaced,
  advertiserId,
  submissionDateUtc,
}: UpdateJobPlacementInput) => {
  await hirerGraphqlClient.mutate<
    UpdateJobPlacementMutation,
    UpdateJobPlacementMutationVariables
  >({
    variables: {
      input: {
        isPlaced,
        jobId,
        advertiserId,
        submissionDateUtc,
        postType,
        submitted,
        userId,
      },
    },
    mutation,
  });
};
